export const TASK_TYPE_LABELS = {
  report_writer: "Report",
  question_answer: "AI Review",
  sources_update: "Source Analysis",
};
